import { render } from "./Sidebar3.vue?vue&type=template&id=78c0682d"
import script from "./Sidebar3.vue?vue&type=script&lang=js"
export * from "./Sidebar3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__